import NoProductFound from '@Icons/search-company-icon.svg?react'

function ProductsErrorResult({
  fetcher,
}: {
  fetcher: (preferCache?: boolean) => void
}): JSX.Element {
  const handleClick = (): void => {
    fetcher(false)
  }

  return (
    <div className="flex flex-col h-full justify-center items-center">
      <NoProductFound />
      <span className="font-medium text-xl text-gray-900 pb-2 pt-5">
        Oops! We could not list your products.
      </span>
      <button
        type="button"
        onClick={handleClick}
        className="border border-solid border-primary-600 py-2 px-4 font-normal text-base text-white-100 shadow-sm rounded-lg bg-primary-600 h-11 disabled:opacity-75"
      >
        Click here to try again manually
      </button>
    </div>
  )
}

export default ProductsErrorResult
